module.exports = __webpack_public_path__ + "img/Sponga_Button_EN.0a48b486.png";